module.exports = __webpack_public_path__ + "img/23_rain.801e763f.jpg";